import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { PatientService } from "@main/app-layout/components/patient-switch/patient.service";

export const patientSelectedContextVariableInterceptor: HttpInterceptorFn = (req, next) => {
    const currentPatientId = inject(PatientService)?.currentPatientId ?? "";

    const headers = req.headers.set("X-Selected-Patient-Id", currentPatientId);
    const nextReq = req.clone({ headers });

    return next(nextReq);
};
